import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AccessibiliteService {
  setFocus(selector: string, timeout: number = 200): void {
    if (selector !== null && selector !== undefined) {
      setTimeout(() => {
        const element: HTMLElement = document.querySelector(selector);
        if (element) {
          element.ariaHidden = 'false';
          element.focus();
        }
      }, timeout);
    }
  }
}
